import { Item, ParentItem } from "../schema/item.js";

export type utilContents = "information" | "howtouse" | "setting" | null;
export type mainContents = "verse" | "verse_oa" | "mix" | "pm";

export const getContentsInVerseOrPM = (
  targetItem: Item | ParentItem
): mainContents => {
  if (targetItem.id.endsWith("PM")) return "pm";
  if (targetItem.id.startsWith("oa-")) return "verse_oa";
  return "verse";
};
